module.exports = __webpack_public_path__ + "img/softinya-2.4e15f20b.png";